import React, { useState } from "react";
import Icon1 from "../icons/Icon.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import Space from "../layout/Space.js";
import { useEffect } from "react";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  updateDocDataField,
} from "../models/DataFunctions.js";
import sendInfiltreaCreateEnveloppeMission from "../api/infiltrea/sendInfiltreaCreateEnveloppeMission.js";
import sendInfiltreaCreateVentilationMission from "../api/infiltrea/sendInfiltreaCreateVentilationMission.js";
import sendInfiltreaCreateOperation from "../api/infiltrea/sendInfiltreaCreateOperation.js";
import { useAppContext } from "../config/AppContext.js";
import { useSnackbar } from "notistack";
import sendInfiltreaThermalFilesFolder from "../api/infiltrea/sendInfiltreaThermalFilesFolder.js";
import CheckBoxGrey from "../textfields/CheckBoxGrey.js";
import loadingAnimation from "../animations/loading.json"; // Path to your JSON file
import { Player } from "@lottiefiles/react-lottie-player";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import DropDownGPTS3 from "../dropdowns/DropDownGPTS3.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import { Spin } from "antd";
import SmallSpinner from "../loading/SmallSpinner.js";

const NewMission = ({ document, folder, orgData, onClose, onUpdate }) => {
  const [step, setStep] = useState("choice");

  const [allfields, setAllFields] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [path, setPath] = useState("");
  const [url, setUrl] = useState("");
  const [selected_files, setSelectedFiles] = useState([]);
  const [documents, setDocuments] = useState([]);

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [operators, setOperators] = useState([]);
  const [operator, setOperator] = useState("");
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [loadingMission, setLoadingMission] = useState(false);
  const [bookshelf, setBookshelf] = useState([]);
  const [maj, setMAJ] = useState(false);

  const [missions, setMissions] = useState([
    { value: "Mission Enveloppe", label: "Mission Enveloppe" },
    { value: "Mission Ventilation", label: "Mission Ventilation" },
  ]);
  const [mission, setMission] = useState("");

  const handleFetchData = async () => {
    if (orgData) {
      const docs = await getArrayDocDataByRef(folder.documents);
      const bookshelf = orgData.bookshelf_id
        ? await getDocDataById("bookshelf", orgData.bookshelf_id)
        : null;
      setBookshelf(bookshelf);
      setDocuments(docs);
      let members = [];
      if (folder.members_id) {
        members = await getArrayDocDataByID("user", folder.members_id);
      }

      const users = await getArrayDocDataByID("user", orgData.users_id);
      const operators = users.filter((user) => user.role === "operator");
      if (operators.length === 0) {
      }
      const operators_dict = operators.map((operator) => ({
        value: operator.id,
        label: operator.display_name,
      }));
      setOperators(operators_dict);
      setOperator(members.length > 0 ? members[0].id : operators_dict[0].value);
      setMission(missions[0].value);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, [orgData]);

  const handleGenerateMission = async () => {
    if (!orgData.infiltrea?.connected === true) {
      handleClickVariant(
        "Vous n'avez pas activé l'intégration à Infiltrea",
        "error"
      );
      return;
    }
    setLoadingMission(true);
    try {
      const token = await getOrRefreshFirebaseToken();
      const folderId = folder.id;
      let res = await sendInfiltreaCreateOperation(
        folderId,
        operator,
        token,
        prefix
      );

      if (res.success !== true) {
        handleClickVariant(
          "Erreur lors de la création de l'opération",
          "error"
        );
        setLoadingMission(false);
        handleClickVariant(res.detail, "error");
        return;
      }

      const operation_id = res.operation_id;
      let thermal_res = await sendInfiltreaThermalFilesFolder(
        folderId,
        orgData.id,
        selected_files.map((file) => file.id),
        operation_id,
        maj,
        token,
        prefix
      );

      if (thermal_res.success !== true) {
        handleClickVariant(
          "Erreur lors de l'envoi des fichiers thermiques",
          "error"
        );
        setLoadingMission(false);
        handleClickVariant(thermal_res.detail, "error");
        return;
      }

      let missionid = "";
      if (mission === "Mission Enveloppe") {
        let enveloppe_res = await sendInfiltreaCreateEnveloppeMission(
          folderId,
          operation_id,
          operator,
          token,
          prefix
        );
        if (enveloppe_res.success !== true) {
          handleClickVariant(
            "Erreur lors de la création de la mission enveloppe",
            "error"
          );
          setLoadingMission(false);
          handleClickVariant(enveloppe_res.detail, "error");
          return;
        }
        missionid = enveloppe_res.detail.id;
      } else if (mission === "Mission Ventilation") {
        let vmc_res = await sendInfiltreaCreateVentilationMission(
          folderId,
          operation_id,
          operator,

          token,
          prefix
        );
        if (vmc_res.success !== true) {
          handleClickVariant(
            "Erreur lors de la création de la mission enveloppe",
            "error"
          );
          setLoadingMission(false);
          handleClickVariant(vmc_res.detail, "error");
          return;
        }
        missionid = vmc_res.detail.id;
      } else if (mission === "Mission Enveloppe + Ventilation") {
        let res_1 = await sendInfiltreaCreateEnveloppeMission(
          folderId,
          operation_id,
          operator,
          token,
          prefix
        );
        let res_2 = await sendInfiltreaCreateVentilationMission(
          folderId,
          operation_id,
          operator,
          token,
          prefix
        );
        if (res_1.success !== true || res_2.success !== true) {
          handleClickVariant(
            "Erreur lors de la création de la mission enveloppe",
            "error"
          );
          setLoadingMission(false);
          handleClickVariant(res_1.detail, "error");
          handleClickVariant(res_2.detail, "error");
          return;
        }
        missionid = res_1.detail.id;
      }

      if (folder.event_ref) {
        await updateDocDataFieldApi(
          folder.event_ref,
          "infiltrea",
          true,
          prefix
        );
      }

      handleClickVariant("Mission infiltrea créée avec succès", "success");
      onUpdate();
      onClose();
    } catch (e) {
      console.error(e);
      handleClickVariant("Erreur lors de la création de la mission", "error");
    }
    setLoadingMission(false);
  };

  function no_document() {
    return (
      folder?.thermal?.files?.length !== 0 ||
      documents.some((doc) => doc.files?.length > 0)
    );
  }

  function no_xml() {
    return folder?.xml?.file?.id === undefined;
  }

  return (
    <div className="flex flex-col p-3 gap-1 bg-white rounded-xl max-w-c400">
      {step === "choice" && (
        <>
          <div className=" text-h2">Création de mission Infiltrea</div>
          <div className=" text-h3 text-shadow_50">
            Sélectionnez un type de mission pour créer une mission sur votre
            interface infiltrea à partir des informations du dossier.
          </div>

          {!loadingMission && (
            <>
              <Space y={10} />
              <DropDownGPT03
                label="Type de mission"
                className="w-full"
                value={mission}
                items={missions}
                onChange={(e) => setMission(e.value)}
              ></DropDownGPT03>{" "}
              <Space y={10} />
              <DropDownGPT03
                label="Opérateur"
                className="w-full"
                value={operator}
                items={operators}
                onChange={(e) => setOperator(e.value)}
              ></DropDownGPT03>
              {folder.modif_thermal?.xml?.file && (
                <div className="flex flex-row items-center gap-2 mt-2">
                  <CheckBoxGrey
                    onChange={() => {
                      setMAJ(!maj);
                    }}
                    checked={maj}
                  />
                  <div className="text-h3 text-black">
                    Utiliser le xml de la mise à jour
                  </div>
                </div>
              )}
              <Space y={10} />
              {!no_document() && (
                <div className="text-h3 text-shadow_50">
                  Aucun fichier n'a été trouvé dans le dossier ou les documents
                  associés pour être envoyé en annexe de la mission infiltrea.
                </div>
              )}
              {no_document() && (
                <>
                  <div className="text-h3 text-shadow_50">
                    Sélectionnez les fichiers thermiques que vous voulez envoyer
                    en annexe de la mission infiltrea.
                  </div>
                  <Space y={2} />
                  <div className="flex flex-col gap-1 overflow-auto max-h-c200 border-1 rounded-md border-shadow_25 p-1">
                    {folder.thermal?.files.map((file, file_index) => (
                      <div
                        className="flex flex-row items-center gap-2"
                        key={file_index}
                      >
                        <CheckBoxGrey
                          onChange={() => {
                            if (selected_files.includes(file)) {
                              setSelectedFiles(
                                selected_files.filter((f) => f !== file)
                              );
                            } else {
                              setSelectedFiles([...selected_files, file]);
                            }
                          }}
                          checked={selected_files.includes(file)}
                        />
                        <div className="text-h4 text-shadow_50">
                          {file.name}
                        </div>
                      </div>
                    ))}
                    {documents.map((doc, index_doc) => (
                      <div key={index_doc}>
                        {doc.files?.map((file, file_index) => (
                          <div
                            key={file_index}
                            className="flex flex-row items-center gap-2"
                          >
                            <CheckBoxGrey
                              onChange={() => {
                                if (selected_files.includes(file)) {
                                  setSelectedFiles(
                                    selected_files.filter((f) => f !== file)
                                  );
                                } else {
                                  setSelectedFiles([...selected_files, file]);
                                }
                              }}
                              checked={selected_files.includes(file)}
                            />
                            <div className="text-h4 text-shadow_50">
                              {file.name.length > 50
                                ? file.name.slice(0, 50)
                                : file.name}
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                    {bookshelf?.files_infiltrea?.length > 0 && (
                      <div className="border-l-2 border-orange-400 pl-2 p-1 bg-orange-50 rounded-lg">
                        <div className="text-h3 text-shadow_50 flex flex-row items-center gap-2 mb-2 ">
                          <Icon1
                            icon_name="bookshelf"
                            size={16}
                            fill="grey"
                          ></Icon1>{" "}
                          Bibliothèque Infiltrea
                        </div>
                        <div className="flex flex-col gap-1 ">
                          {bookshelf?.files_infiltrea?.map(
                            (file, file_index) => (
                              <div
                                key={file_index}
                                className="flex flex-row items-start gap-2 "
                              >
                                <CheckBoxGrey
                                  onChange={() => {
                                    if (selected_files.includes(file)) {
                                      setSelectedFiles(
                                        selected_files.filter((f) => f !== file)
                                      );
                                    } else {
                                      setSelectedFiles([
                                        ...selected_files,
                                        file,
                                      ]);
                                    }
                                  }}
                                  checked={selected_files.includes(file)}
                                />

                                <div className="text-h4 text-shadow_50 ">
                                  {file.name.length > 50
                                    ? file.name.slice(0, 50)
                                    : file.name}
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )}
                  </div>{" "}
                </>
              )}{" "}
              <Space y={5} />
              {no_xml() && (
                <div className="text-h3  p-2 bg-red-50 border-1 border-red-400 rounded-md text-red-500">
                  Aucun fichier XML n'a été trouvé dans le dossier donc si vous
                  générez une mission infiltrea, il n'y aura pas de fichier XML
                  associé.
                </div>
              )}
              {!no_xml() && (
                <div className="text-h3  p-2 bg-green-50 border-1 border-green-400 rounded-md text-green-500">
                  Fichier XML trouvé dans le dossier.
                </div>
              )}
              <Space y={5} />
            </>
          )}
          {loadingMission ? (
            <div className="flex flex-col my-4 items-center justify-center">
              <SmallSpinner></SmallSpinner>
            </div>
          ) : (
            <PrimaryButton onClick={handleGenerateMission}>
              Générer Mission Infiltrea
            </PrimaryButton>
          )}
        </>
      )}
    </div>
  );
};

export default NewMission;
